import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=74b0bf9e"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=74b0bf9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports